export default {
  methods: {
    $debug: function $debug(error) {
      if (error.response && error.response.status === 401) {
        this.$router.push({
          name: 'error401'
        });
        return false;
      } else if (error.response && error.response.status === 422) {
        this.$root.$emit('showValidationsModal', error.response.data.errors);
      } else if (error.response && error.response.status === 404) {
        this.$router.push({
          name: 'error404'
        });
      } else {
        console.log(error);
      }
      return true;
    }
  }
};